<template>
	<div class="sendGood">
		<el-dialog :title="title" width="30%" :visible.sync="dialogSendVisible" @close="resetForms('sendFrom')">
			<div class="product_box">
				<product-box :row="row" :tabName="tabName"></product-box>
			</div>
			<div class="user_info_box mt-10">
				<user-info-box :row="row" :tabName="tabName"></user-info-box>
			</div>
			<div class="mt-20">
				<el-form :model="sendFrom" ref="sendFrom" :rules="sendRuels">
					<el-form-item label="物流单号：" :label-width="formLabelWidth" prop="shipping_sn">
						<el-input
							v-model="sendFrom['shipping_sn']"
							@keyup.enter.native="handleEnterEvent"
							@blur="handleEnterEvent"
							autocomplete="off"
							placeholder="请输入物流单号"
						></el-input>
					</el-form-item>
					<el-form-item label="物流公司：" :label-width="formLabelWidth" prop="shipping_company">
						<el-select v-model="sendFrom['shipping_company']" filterable @change="getCompanyFun" placeholder="请选择物流公司">
							<el-option :label="item.express_name" :value="item.express_name" v-for="(item, index) in companyArr" :key="index"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogSendVisible = false">取 消</el-button>
				<el-button type="primary" @click="sendConfirm">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import productBox from '@/components/common/productBox';
import userInfoBox from '@/components/common/userInfoBox';
import { OrderDeliver, expressList, updShipping } from '@/api/cooperationProgress';
import { getDeliveryInfo } from '@/api/sampleOrder';
export default {
	components: {
		productBox,
		userInfoBox,
	},
	name: 'sendGood',
	data() {
		return {
			dialogSendVisible: false,
			sendFrom: {
				shipping_company: '',
				shipping_sn: '',
				shipping_code: '',
				status: '1',
				cooperate_id: '',
				sample_sn: '',
			},
			sendRuels: {
				shipping_company: [{ required: true, message: '请输入物流公司', trigger: 'blur' }],
				shipping_sn: [{ required: true, message: '请输入物流单号', trigger: 'blur' }],
			},
			formLabelWidth: '100px',
			row: {},
			companyArr: [],
			state: '',
			tabName: '',
			title: '',
		};
	},
	methods: {
		async initSendFun(row, tabName, state) {
			this.tabName = tabName;
			this.state = state;
			this.title = state ? '修改物流信息' : '发货';
			if (state) {
				this.sendFrom.shipping_company = row.shipping_company;
				this.sendFrom.shipping_code = row.shipping_code;
				this.sendFrom.shipping_sn = row.shipping_sn;
			}
			this.row = row;
			this.sendFrom.cooperate_id = row.cooperate_id;
			this.sendFrom.sample_sn = row.sample_sn;
			this.dialogSendVisible = true;
			const { code, data } = await expressList({});
			if (code == 0) {
				this.companyArr = data;
			}
		},
		async handleEnterEvent() {
			if (!this.sendFrom['shipping_sn']) return;
			try {
				let data = await getDeliveryInfo({
					deliveryCode: this.sendFrom['shipping_sn'],
				});
				this.sendFrom['shipping_company'] = data?.deliveryName || '';
				this.sendFrom['shipping_code'] = data?.expressCode || '';
			} catch (e) {}
		},
		sendConfirm() {
			this.$refs.sendFrom.validate(async valid => {
				if (valid) {
					if (this.state) {
						const { code } = await updShipping(this.sendFrom);
						if (code == 0) {
							this.dialogSendVisible = false;
							this.$message.success('修改成功');
							this.$emit('refreshList');
						}
					} else {
						const { code } = await OrderDeliver(this.sendFrom);
						if (code == 0) {
							this.dialogSendVisible = false;
							this.$message.success('发货成功');
							this.$emit('refreshList');
						}
					}
				}
			});
		},
		//重置弹框表单
		resetForms(from) {
			this.$refs[from].resetFields();
			this.sendFrom = {
				shipping_company: '',
				shipping_sn: '',
				shipping_code: '',
				status: '1',
				cooperate_id: '',
				sample_sn: '',
			};
		},
		getCompanyFun(e) {
			this.companyArr.forEach((item, index) => {
				if (item.express_name == e) {
					this.sendFrom.shipping_code = item.express_code;
				}
			});
		},
	},
};
</script>
<style lang="less" scoped>
/deep/ .el-select {
	width: 100%;
}
</style>
